// src/utils/faceUtils.js
import * as faceapi from "face-api.js";
import api from "../api/api";

// Load ML models from local public folder (call once on page load)
export const loadModels = async () => {
  const MODEL_URL = "/models"; // public/models folder in React

  try {
    await faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL);
    console.log("✅ tinyFaceDetector loaded");

    await faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL);
    console.log("✅ faceLandmark68Net loaded");

    await faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL);
    console.log("✅ faceRecognitionNet loaded");

    console.log("✅ All face-api models loaded successfully");
  } catch (err) {
    console.error("❌ Model load error from local folder:", MODEL_URL);
    console.error(err);
    throw err;
  }
};

// Capture face embedding from existing video element
export const getFaceEmbedding = async (video) => {
  if (!video) return null;

  try {
    const detection = await faceapi
      .detectSingleFace(video, new faceapi.TinyFaceDetectorOptions())
      .withFaceLandmarks()
      .withFaceDescriptor();

    if (!detection) return null;
    return Array.from(detection.descriptor); // 128-d embedding
  } catch (err) {
    console.error("❌ Face detection error:", err);
    return null;
  }
};

// Compare embeddings using cosine similarity
export const compareEmbeddings = (embedding1, embedding2, threshold = 0.6) => {
  if (!embedding1 || !embedding2 || embedding1.length !== embedding2.length)
    return false;

  const dot = embedding1.reduce((sum, v, i) => sum + v * embedding2[i], 0);
  const norm1 = Math.sqrt(embedding1.reduce((sum, v) => sum + v * v, 0));
  const norm2 = Math.sqrt(embedding2.reduce((sum, v) => sum + v * v, 0));
  const similarity = dot / (norm1 * norm2);

  return similarity > threshold;
};
